import React from 'react';

const Inventory = () => {
    document.title = "Inventory";
    return (
        <div>
            <h2>Inventory Coming Soon...</h2>
        </div>
    );
};

export default Inventory;